import React, { createContext, useContext, useState, useEffect, useMemo } from 'react'

const AuthContext = createContext(null)

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  const logout = () => {
    localStorage.removeItem('token')
    window.location.href = '/'
    setUser(null)
  }
  const fetchUser = async () => {
    try {
      const token = localStorage.getItem('token')

      if (!token) {
        setUser(null)
        setLoading(false)
        return
      }

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      if (!response.ok) {
        throw new Error(`Failed to fetch user: ${response.status}`)
      }

      const data = await response.json()
      setUser(data ?? null)
    } catch (error) {
      console.error('AuthProvider error', error)
      setUser(null)
      localStorage.removeItem('token')
    } finally {
      setLoading(false)
    }
  }
  
  useEffect(() => {
    fetchUser()
  }, [localStorage.getItem('token')])

  const contextValue = useMemo(() => ({ user, loading, logout, fetchUser }), [user, loading, logout, fetchUser]);
  return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
